module.exports = __webpack_public_path__ + "img/welcome-new@2x.4af37621.png";